$(document).ready(function(){
    handleMobileNavCollapses();
    openLoginByDefaultOnDesktop();
    //Password field no longer shown on homepage
    //setupTogglePasswordVisibility();
    setupRememberMe();
});

//Make sure only one of the Mobile Nav collapses is open at a time
function handleMobileNavCollapses(){
    const mobileSignIn = new bootstrap.Collapse('#signInMobileCollapse',{
        toggle: false
    });
    const mobileNavContent = new bootstrap.Collapse('#navContent',{
        toggle: false
    });
    document.getElementById('signInMobileCollapse').addEventListener('show.bs.collapse', function () {
        mobileNavContent.hide();
    });
    document.getElementById('navContent').addEventListener('show.bs.collapse', function () {
        mobileSignIn.hide();
    })
}

function openLoginByDefaultOnDesktop(){
    const urlPathName = window.location.pathname;
    var openedProgrammatically = false
    //Open only on homepage (EN and ES)
    const isInHome = urlPathName === '/' || urlPathName === '/es/' || urlPathName === '/amerant-bank-2022/' || urlPathName === '/amerant-bank-2022/es/';
    const isInBusiness = urlPathName.search('/business/') !== -1 || urlPathName.search('/banca-empresarial/') !== -1;
    if(isInHome || isInBusiness){
        //Skip if cookie is set
        if(document.cookie.split('; ').find((row) => row.startsWith('skipAutoLoginOpen'))) return;
        //Open only on desktop
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (width < 992) return;

        setTimeout(function (){
            const signInButton = document.getElementById('signInDesktop');
            if(signInButton.getAttribute('aria-expanded') === 'false'){
                signInButton.click();
                if(isInBusiness) {
                    const treasuryConnectButton = document.getElementById('business-mobile-tab');
                    treasuryConnectButton.click();
                }
                openedProgrammatically = true;
                const signInDesktopCollapse = document.querySelector('#signInDesktopCollapse');
                signInDesktopCollapse.addEventListener('hide.bs.collapse', function () {
                    //set cookie so it doesn't open again automatically this session
                    document.cookie = "skipAutoLoginOpen=true;";
                });
            }
        },1000);
    }
}

function setupTogglePasswordVisibility(){
    document.getElementById('toggle-password-visibility-personal-user-password-Desktop').addEventListener('click', function () {
        togglePasswordFieldType('personal-user-password-Desktop');
    });
    document.getElementById('toggle-password-visibility-personal-user-password-Mobile').addEventListener('click', function () {
        togglePasswordFieldType('personal-user-password-Mobile')
    });
}

function togglePasswordFieldType(inputFieldId){
    const passwordField = document.getElementById(inputFieldId);
    if(passwordField.type === 'password'){
        passwordField.type = 'text';
    }else if(passwordField.type === 'text') {
        passwordField.type = 'password';
    }
}

function setupRememberMe() {
    const cookieUserIdValue =  getCookie('personal-form-user-id');
    if(cookieUserIdValue){
        document.getElementById('personal-user-id-Desktop').value = cookieUserIdValue;
        document.getElementById('personal-remember-me-Desktop').checked = true;
        document.getElementById('personal-user-id-Mobile').value = cookieUserIdValue;
        document.getElementById('personal-remember-me-Mobile').checked = true;
    }
    setupRememberListener('Desktop');
    setupRememberListener('Mobile');
}

function setupRememberListener(suffix){
    document.getElementById('personal-form-'+suffix).addEventListener('submit', function (){
        const checkbox = document.getElementById('personal-remember-me-'+suffix);
        if(checkbox.checked){
            setCookie('personal-form-user-id',document.getElementById('personal-user-id-'+suffix).value,90);
        }else{
            deleteCookie('personal-form-user-id');
        }
    });
}

function setCookie(name, value, days) {
    let today = new Date();
    let expiry = new Date(today.getTime() + days * 24 * 3600 * 1000); // plus 30 days
    document.cookie=name + "=" + escape(value) + "; path=/; expires=" + expiry.toGMTString();
}

function getCookie(name){
    let re = new RegExp(name + "=([^;]+)");
    let value = re.exec(document.cookie);
    return (value != null) ? unescape(value[1]) : null;
}

function deleteCookie(name){
    document.cookie=name + "=" + "; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
}